import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import { ROUTES } from 'constants/routes';

/* ── Scroll to top on route change ── */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

/* ── Layout wrapper ── */
const Layout = ({ children }) => {
  const location = useLocation();
  const noFooter = [ROUTES.discover]; // map page — no footer
  const isLanding = location.pathname === ROUTES.home;
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>{children}</main>
      {!noFooter.includes(location.pathname) && <Footer variant={isLanding ? 'full' : 'minimal'} />}
    </>
  );
};

export default Layout;
